export enum Side {
    BUY = 'BUY',
    SELL = 'SELL',
}

export enum OrderType {
    MARKET = 'MARKET',
    LIMIT = 'LIMIT',
    STOP = 'STOP',
}

export enum OrderAction {
    NEW = 'NEW',
    CLOSE = 'CLOSE',
    TRADE = 'TRADE',
}
